<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('PARTNERORDER.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('PARTNERORDER.HEADER.TEXT')}}</span>
        </p>
        <ConvertPartnerOrderDlg ref="convertPartnerOrderDlg" v-on:Success="OrderConverted"></ConvertPartnerOrderDlg>
      </vs-card>
    </vs-col>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
      <vs-card >
            <div id="partnerorders_table" class="vs-con-loading__container" >
              <vs-table
                search
                :data="partnerorders"
                :noDataText="$t('PARTNERORDER.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('PARTNERORDER.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">                               
                  <vs-th sort-key="bez">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL1')}}
                  </vs-th>
                  <vs-th sort-key="sent_at">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL2')}}
                  </vs-th>
                  <vs-th sort-key="order_nr">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL3')}}
                  </vs-th>
                  <vs-th sort-key="company_name">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL4')}}
                  </vs-th> 
                  <vs-th sort-key="netto_sum">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL5')}}
                  </vs-th>
                  <vs-th sort-key="state">
                    {{$t('PARTNERORDER.FOR_ME_TABLE.COL6')}}
                  </vs-th>                                                                                                           
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                    <vs-td :data="tr.bez">
                      {{tr.bez}}
                    </vs-td> 
                    <vs-td :data="tr.sent_at">
                      {{DateToString(tr.sent_at,false)}}
                    </vs-td>         
                    <vs-td :data="tr.order_nr">
                      {{tr.order_nr}}
                    </vs-td>                                                                                                    
                    <vs-td :data="tr.company_name">
                      {{tr.company_name}}
                    </vs-td> 
                    <vs-td :data="tr.netto_sum">
                      {{GetCurrencyStringForPartnerOrder(tr)}}
                    </vs-td>
                    <vs-td :data="tr.state">
                      <vs-chip :color="GetCommonStateColor(tr.state)">{{GetCommonStateText(tr.state)}}</vs-chip>
                    </vs-td>
                    <vs-td>
                      <div class="d-flex">
                      <vs-button  @click="ShowPartnerOrder(tr)" class="" size="small" color="primary" type="filled" icon="open_in_new"></vs-button>
                      <vs-button :disabled="tr.state != SENT" @click="OpenConfirmConvertOffer(tr.id,tr.bez)" class="ml-2" size="small" color="success" type="filled" icon="assignment_turned_in"></vs-button>
                      </div>
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div>           
        </vs-card>
      </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';
import ConvertPartnerOrderDlg from './components/dialogs/ConvertPartnerOrderDlg.vue';
import {commonStates} from '../helper/enumHelper';

export default {
  name: "PartnerOrdersForMe",
  components: {
    ConvertPartnerOrderDlg
  },
    data: function (){
      return {
      partnerorders:[],
      SENT:commonStates.SENT
      };
  },
  mounted () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.partnerorder.partnerordersForMe.data != null)
      {
        data = this.$store.state.partnerorder.partnerordersForMe.data
      }
      return data;
    },
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.partnerorder.partnerordersForMe.status) != 'undefined')
        loading = this.$store.state.partnerorder.partnerordersForMe.status.loading;
      return loading;
    },
    
  },
  watch: {
      getTableData(value) {
          this.partnerorders = value;
      },
      loadingTableData(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#partnerorders_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#partnerorders_table'});
        }
      },
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
      LoadData: function ()
      {
          this.$store.dispatch('partnerorder/getPartnerOrdersForMe'); 
      },
      ShowPartnerOrder(data){
        this.$router.push({ name: 'PartnerOrder', params: { partnerorder_fk: data.id, editable:false } });
      },
      GetCurrencyStringForPartnerOrder(order){
        var ret = "";
        if(this.IsNotNull(order))
        {
          ret = this.GetCurrencyString(order.netto_sum,order.member[0].language_fk,order.member[0].currency_kuerzel);
        }
        return ret;
      },
      GetCurrencyString(amount,language_fk,currency_kuerzel){
        if(this.IsNotNull(amount) && this.IsNotNull(language_fk) && this.IsNotNull(currency_kuerzel))
        {
          return this.DecimalToString(amount,currency_kuerzel,this.GetLocalFormatOfLanguage(language_fk));
        }
        else
        {
          return "";
        }
      },
      OpenConfirmConvertOffer(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.CONVERT'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('PARTNERORDER.QUESTION.CONVERT').replace("*1*",name),
          accept: this.ConvertToOfferRequest,
          parameters:{"id": id,"name": name}
        });
      
      },
      ConvertToOfferRequest: function(parameters)
      {
        this.$refs.convertPartnerOrderDlg.ShowDlg(parameters.id);
      },

      OrderConverted(id)
      {
        this.$router.push({ name: 'Offer', params: { offer_fk: id, editable:true, for_partnerorder_fk:0 } });
      }
  }
};

</script>